import { useEffect } from 'react';
import useIsIRP from '@rsos/utils/useIsIRP';
import { SOURCE_911INFORM } from '../../SpatialLayers/spatialLayersSources';
import IconPolygonLayer from '../RSOSLayers/IconPolygonLayer';
import { default as IconLayer } from '../RSOSLayers/RSOSIconLayer';
import { trackActiveGeofenceHover } from '../spatialTracking';
import {
  trackDeckGLClickOnSpatialObject,
  trackDeckGLHoverOnSpatialObject,
} from '../spatialTracking';
import storeLayers from '../storeLayers';

const StaticLayerGL = ({
  overlay,
  activeMarkerId,
  onClick = () => {},
  onHover = () => {},
  spatialLayer = null,
  filled = true,
}) => {
  const {
    spatial_objects: data,
    key: spatialLayerID = '',
    source: spatialLayerSource = '',
    isChecked: visible = true,
  } = spatialLayer;
  const irpVersion = useIsIRP().irpVersion;
  useEffect(() => {
    const iconPolygonLayer = new IconPolygonLayer({
      id: `${spatialLayerID}`,
      data,
      activeMarkerId,
      visible,
      filled,
      autoHighlight: true,

      onClick: info => {
        if (info.sourceLayer instanceof IconLayer) {
          trackDeckGLClickOnSpatialObject({
            irpVersion,
            externalId: info?.object?.external_id,
            source: spatialLayerSource,
          });
        }
        onClick(info.object, spatialLayer);
      },

      onHover: info => {
        if (info.object) {
          if (info.sourceLayer instanceof IconLayer) {
            trackDeckGLHoverOnSpatialObject({
              irpVersion,
              source: spatialLayerSource,
            });
          }
          if (
            spatialLayer.source === SOURCE_911INFORM &&
            info.object?.status === 'active'
          ) {
            trackActiveGeofenceHover(irpVersion);
          }
          try {
            const pos = info?.viewport.project(info.coordinate);
            onHover({
              coordinate: { x: pos[0], y: pos[1] },
              spatialObject: info.object,
              spatialLayer,
            });
          } catch (err) {
            throw new Error(err);
          }
          overlay.setCursorPointer();
        } else {
          onHover(null);
          overlay.setCursorDefault();
        }
      },

      updateTriggers: {
        getIcon: [activeMarkerId],
        getLineColor: [activeMarkerId],
        visible: [visible],
      },
    });

    if (overlay) {
      storeLayers.save(iconPolygonLayer);
      overlay.setLayers(storeLayers.getAll());
    }
  }, [activeMarkerId, data, overlay, visible]);

  return null;
};

export default StaticLayerGL;
